/**
 * Country & currency reference data, plus the mapping from ISO countries to the
 * nomenclatures and calculators supported by the classification/duty engine.
 */

export const COUNTRIES = [
  ['AD', 'Andorra'],
  ['AE', 'United Arab Emirates'],
  ['AF', 'Afghanistan'],
  ['AG', 'Antigua and Barbuda'],
  ['AI', 'Anguilla'],
  ['AL', 'Albania'],
  ['AM', 'Armenia'],
  ['AO', 'Angola'],
  ['AQ', 'Antarctica'],
  ['AR', 'Argentina'],
  ['AS', 'American Samoa'],
  ['AT', 'Austria'],
  ['AU', 'Australia'],
  ['AW', 'Aruba'],
  ['AX', 'Åland Islands'],
  ['AZ', 'Azerbaijan'],
  ['BA', 'Bosnia and Herzegovina'],
  ['BB', 'Barbados'],
  ['BD', 'Bangladesh'],
  ['BE', 'Belgium'],
  ['BF', 'Burkina Faso'],
  ['BG', 'Bulgaria'],
  ['BH', 'Bahrain'],
  ['BI', 'Burundi'],
  ['BJ', 'Benin'],
  ['BL', 'Saint Barthélemy'],
  ['BM', 'Bermuda'],
  ['BN', 'Brunei'],
  ['BO', 'Bolivia'],
  ['BQ', 'Caribbean Netherlands'],
  ['BR', 'Brazil'],
  ['BS', 'Bahamas'],
  ['BT', 'Bhutan'],
  ['BV', 'Bouvet Island'],
  ['BW', 'Botswana'],
  ['BY', 'Belarus'],
  ['BZ', 'Belize'],
  ['CA', 'Canada'],
  ['CC', 'Cocos (Keeling) Islands'],
  ['CD', 'DR Congo'],
  ['CF', 'Central African Republic'],
  ['CG', 'Republic of the Congo'],
  ['CH', 'Switzerland'],
  ['CI', "Côte d'Ivoire"],
  ['CK', 'Cook Islands'],
  ['CL', 'Chile'],
  ['CM', 'Cameroon'],
  ['CN', 'China'],
  ['CO', 'Colombia'],
  ['CR', 'Costa Rica'],
  ['CU', 'Cuba'],
  ['CV', 'Cape Verde'],
  ['CW', 'Curaçao'],
  ['CX', 'Christmas Island'],
  ['CY', 'Cyprus'],
  ['CZ', 'Czechia'],
  ['DE', 'Germany'],
  ['DJ', 'Djibouti'],
  ['DK', 'Denmark'],
  ['DM', 'Dominica'],
  ['DO', 'Dominican Republic'],
  ['DZ', 'Algeria'],
  ['EC', 'Ecuador'],
  ['EE', 'Estonia'],
  ['EG', 'Egypt'],
  ['EH', 'Western Sahara'],
  ['ER', 'Eritrea'],
  ['ES', 'Spain'],
  ['ET', 'Ethiopia'],
  ['FI', 'Finland'],
  ['FJ', 'Fiji'],
  ['FK', 'Falkland Islands'],
  ['FM', 'Micronesia'],
  ['FO', 'Faroe Islands'],
  ['FR', 'France'],
  ['GA', 'Gabon'],
  ['GB', 'United Kingdom'],
  ['GD', 'Grenada'],
  ['GE', 'Georgia'],
  ['GF', 'French Guiana'],
  ['GG', 'Guernsey'],
  ['GH', 'Ghana'],
  ['GI', 'Gibraltar'],
  ['GL', 'Greenland'],
  ['GM', 'Gambia'],
  ['GN', 'Guinea'],
  ['GP', 'Guadeloupe'],
  ['GQ', 'Equatorial Guinea'],
  ['GR', 'Greece'],
  ['GS', 'South Georgia and the South Sandwich Islands'],
  ['GT', 'Guatemala'],
  ['GU', 'Guam'],
  ['GW', 'Guinea-Bissau'],
  ['GY', 'Guyana'],
  ['HK', 'Hong Kong'],
  ['HM', 'Heard Island and McDonald Islands'],
  ['HN', 'Honduras'],
  ['HR', 'Croatia'],
  ['HT', 'Haiti'],
  ['HU', 'Hungary'],
  ['ID', 'Indonesia'],
  ['IE', 'Ireland'],
  ['IL', 'Israel'],
  ['IM', 'Isle of Man'],
  ['IN', 'India'],
  ['IO', 'British Indian Ocean Territory'],
  ['IQ', 'Iraq'],
  ['IR', 'Iran'],
  ['IS', 'Iceland'],
  ['IT', 'Italy'],
  ['JE', 'Jersey'],
  ['JM', 'Jamaica'],
  ['JO', 'Jordan'],
  ['JP', 'Japan'],
  ['KE', 'Kenya'],
  ['KG', 'Kyrgyzstan'],
  ['KH', 'Cambodia'],
  ['KI', 'Kiribati'],
  ['KM', 'Comoros'],
  ['KN', 'Saint Kitts and Nevis'],
  ['KP', 'North Korea'],
  ['KR', 'South Korea'],
  ['KW', 'Kuwait'],
  ['KY', 'Cayman Islands'],
  ['KZ', 'Kazakhstan'],
  ['LA', 'Laos'],
  ['LB', 'Lebanon'],
  ['LC', 'Saint Lucia'],
  ['LI', 'Liechtenstein'],
  ['LK', 'Sri Lanka'],
  ['LR', 'Liberia'],
  ['LS', 'Lesotho'],
  ['LT', 'Lithuania'],
  ['LU', 'Luxembourg'],
  ['LV', 'Latvia'],
  ['LY', 'Libya'],
  ['MA', 'Morocco'],
  ['MC', 'Monaco'],
  ['MD', 'Moldova'],
  ['ME', 'Montenegro'],
  ['MF', 'Saint Martin'],
  ['MG', 'Madagascar'],
  ['MH', 'Marshall Islands'],
  ['MK', 'North Macedonia'],
  ['ML', 'Mali'],
  ['MM', 'Myanmar'],
  ['MN', 'Mongolia'],
  ['MO', 'Macao'],
  ['MP', 'Northern Mariana Islands'],
  ['MQ', 'Martinique'],
  ['MR', 'Mauritania'],
  ['MS', 'Montserrat'],
  ['MT', 'Malta'],
  ['MU', 'Mauritius'],
  ['MV', 'Maldives'],
  ['MW', 'Malawi'],
  ['MX', 'Mexico'],
  ['MY', 'Malaysia'],
  ['MZ', 'Mozambique'],
  ['NA', 'Namibia'],
  ['NC', 'New Caledonia'],
  ['NE', 'Niger'],
  ['NF', 'Norfolk Island'],
  ['NG', 'Nigeria'],
  ['NI', 'Nicaragua'],
  ['NL', 'Netherlands'],
  ['NO', 'Norway'],
  ['NP', 'Nepal'],
  ['NR', 'Nauru'],
  ['NU', 'Niue'],
  ['NZ', 'New Zealand'],
  ['OM', 'Oman'],
  ['PA', 'Panama'],
  ['PE', 'Peru'],
  ['PF', 'French Polynesia'],
  ['PG', 'Papua New Guinea'],
  ['PH', 'Philippines'],
  ['PK', 'Pakistan'],
  ['PL', 'Poland'],
  ['PM', 'Saint Pierre and Miquelon'],
  ['PN', 'Pitcairn Islands'],
  ['PR', 'Puerto Rico'],
  ['PS', 'Palestine'],
  ['PT', 'Portugal'],
  ['PW', 'Palau'],
  ['PY', 'Paraguay'],
  ['QA', 'Qatar'],
  ['RE', 'Réunion'],
  ['RO', 'Romania'],
  ['RS', 'Serbia'],
  ['RU', 'Russia'],
  ['RW', 'Rwanda'],
  ['SA', 'Saudi Arabia'],
  ['SB', 'Solomon Islands'],
  ['SC', 'Seychelles'],
  ['SD', 'Sudan'],
  ['SE', 'Sweden'],
  ['SG', 'Singapore'],
  ['SH', 'Saint Helena'],
  ['SI', 'Slovenia'],
  ['SJ', 'Svalbard and Jan Mayen'],
  ['SK', 'Slovakia'],
  ['SL', 'Sierra Leone'],
  ['SM', 'San Marino'],
  ['SN', 'Senegal'],
  ['SO', 'Somalia'],
  ['SR', 'Suriname'],
  ['SS', 'South Sudan'],
  ['ST', 'São Tomé and Príncipe'],
  ['SV', 'El Salvador'],
  ['SX', 'Sint Maarten'],
  ['SY', 'Syria'],
  ['SZ', 'Eswatini'],
  ['TC', 'Turks and Caicos Islands'],
  ['TD', 'Chad'],
  ['TF', 'French Southern Territories'],
  ['TG', 'Togo'],
  ['TH', 'Thailand'],
  ['TJ', 'Tajikistan'],
  ['TK', 'Tokelau'],
  ['TL', 'Timor-Leste'],
  ['TM', 'Turkmenistan'],
  ['TN', 'Tunisia'],
  ['TO', 'Tonga'],
  ['TR', 'Türkiye'],
  ['TT', 'Trinidad and Tobago'],
  ['TV', 'Tuvalu'],
  ['TW', 'Taiwan'],
  ['TZ', 'Tanzania'],
  ['UA', 'Ukraine'],
  ['UG', 'Uganda'],
  ['UM', 'U.S. Minor Outlying Islands'],
  ['US', 'United States'],
  ['UY', 'Uruguay'],
  ['UZ', 'Uzbekistan'],
  ['VA', 'Vatican City'],
  ['VC', 'Saint Vincent and the Grenadines'],
  ['VE', 'Venezuela'],
  ['VG', 'British Virgin Islands'],
  ['VI', 'U.S. Virgin Islands'],
  ['VN', 'Vietnam'],
  ['VU', 'Vanuatu'],
  ['WF', 'Wallis and Futuna'],
  ['WS', 'Samoa'],
  ['XK', 'Kosovo'],
  ['YE', 'Yemen'],
  ['YT', 'Mayotte'],
  ['ZA', 'South Africa'],
  ['ZM', 'Zambia'],
  ['ZW', 'Zimbabwe'],
] as const satisfies ReadonlyArray<readonly [string, string]>;

export type CountryCode = (typeof COUNTRIES)[number][0];

export interface Country {
  code: string;
  name: string;
  flag: string;
}

export function flagEmoji(code: string): string {
  const upper = code.toUpperCase();
  if (!/^[A-Z]{2}$/.test(upper)) return '🏳️';
  return String.fromCodePoint(...[...upper].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65));
}

export const COUNTRY_LIST: Country[] = COUNTRIES.map(([code, name]) => ({
  code,
  name,
  flag: flagEmoji(code),
}));

const BY_CODE = new Map<string, Country>(COUNTRY_LIST.map((c) => [c.code, c]));

export function getCountry(code: string | null | undefined): Country | undefined {
  return code ? BY_CODE.get(code.toUpperCase()) : undefined;
}

export function countryName(code: string | null | undefined): string {
  return getCountry(code)?.name ?? (code ? code.toUpperCase() : 'Unknown');
}

export function isCountryCode(code: string | null | undefined): boolean {
  return !!code && BY_CODE.has(code.toUpperCase());
}

/* -------------------------------------------------------------------------- */
/* Name → code matching (used to parse "Made in ..." text and free-form input) */
/* -------------------------------------------------------------------------- */

const ALIASES: Record<string, string> = {
  usa: 'US',
  'u s a': 'US',
  'u s': 'US',
  us: 'US',
  america: 'US',
  'united states of america': 'US',
  'the united states': 'US',
  uk: 'GB',
  'u k': 'GB',
  'great britain': 'GB',
  britain: 'GB',
  england: 'GB',
  scotland: 'GB',
  wales: 'GB',
  'northern ireland': 'GB',
  'the united kingdom': 'GB',
  prc: 'CN',
  'p r c': 'CN',
  'peoples republic of china': 'CN',
  'mainland china': 'CN',
  'china mainland': 'CN',
  holland: 'NL',
  'the netherlands': 'NL',
  korea: 'KR',
  'republic of korea': 'KR',
  'korea republic of': 'KR',
  'viet nam': 'VN',
  turkey: 'TR',
  turkiye: 'TR',
  'czech republic': 'CZ',
  'russian federation': 'RU',
  'ivory coast': 'CI',
  'cote divoire': 'CI',
  burma: 'MM',
  macau: 'MO',
  'hong kong sar': 'HK',
  'hong kong china': 'HK',
  uae: 'AE',
  'u a e': 'AE',
  emirates: 'AE',
  deutschland: 'DE',
  italia: 'IT',
  espana: 'ES',
  nippon: 'JP',
  swaziland: 'SZ',
  'cabo verde': 'CV',
  macedonia: 'MK',
  'east timor': 'TL',
  vatican: 'VA',
  'holy see': 'VA',
  'the bahamas': 'BS',
  'the gambia': 'GM',
  congo: 'CG',
  'congo brazzaville': 'CG',
  'congo kinshasa': 'CD',
  drc: 'CD',
  'democratic republic of the congo': 'CD',
  lao: 'LA',
  'lao pdr': 'LA',
  'syrian arab republic': 'SY',
  'iran islamic republic of': 'IR',
  'republic of moldova': 'MD',
  'bolivia plurinational state of': 'BO',
  'tanzania united republic of': 'TZ',
  'brunei darussalam': 'BN',
  'taiwan province of china': 'TW',
  'chinese taipei': 'TW',
  'sri lanka': 'LK',
  'the philippines': 'PH',
  saudi: 'SA',
  ksa: 'SA',
  'south africa': 'ZA',
  'new zealand': 'NZ',
  czechia: 'CZ',
  'slovak republic': 'SK',
  bosnia: 'BA',
  trinidad: 'TT',
  'st lucia': 'LC',
  'st kitts and nevis': 'KN',
  'st vincent and the grenadines': 'VC',
  'palestinian territories': 'PS',
  // As sanctions lists write them (UN, UK, OFAC, MOF): "Korea, Democratic People's Republic of" must not fall back to
  // its first word (South Korea).
  "democratic people's republic of korea": 'KP',
  "korea, democratic people's republic of": 'KP',
  "korea (democratic people's republic of)": 'KP',
  'democratic peoples republic of korea': 'KP',
  'korea north': 'KP',
  dprk: 'KP',
  'korea south': 'KR',
  'united republic of tanzania': 'TZ',
  'state of palestine': 'PS',
  'occupied palestinian territories': 'PS',
  'occupied palestinian territory': 'PS',
  'palestine state of': 'PS',
  'union of the comoros': 'KM',
  'libyan arab jamahiriya': 'LY',
  'st vincent': 'VC',
  'congo democratic republic of the': 'CD',
  'congo republic of the': 'CG',
  'iran islamic republic': 'IR',
  'venezuela bolivarian republic of': 'VE',
  'micronesia federated states of': 'FM',
  'republic of palau': 'PW',
  'republic of belarus': 'BY',
  'west bank': 'PS',
  gaza: 'PS',
  'gaza strip': 'PS',
};

/** Lowercase, strip diacritics/punctuation (apostrophes join: "People's" → "peoples"), collapse whitespace. */
export function normalizeCountryText(input: string): string {
  return input
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/['’]/g, '')
    .replace(/&/g, ' and ')
    .replace(/[^a-z\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

const BY_NAME = new Map<string, string>();
for (const { code, name } of COUNTRY_LIST) BY_NAME.set(normalizeCountryText(name), code);
for (const [alias, code] of Object.entries(ALIASES)) BY_NAME.set(normalizeCountryText(alias), code);

/**
 * Resolve free text ("Made in the P.R.C.", "Viet Nam", "de") to an ISO-3166 alpha-2 code.
 * Tries the whole phrase, then progressively shorter leading word sequences ("China and assembled in" → "China").
 */
export function findCountryCode(text: string | null | undefined): string | undefined {
  if (!text) return undefined;
  const trimmed = text.trim();
  if (/^[A-Za-z]{2}$/.test(trimmed) && BY_CODE.has(trimmed.toUpperCase()))
    return trimmed.toUpperCase();
  const normalized = normalizeCountryText(trimmed).replace(/^the /, '');
  if (!normalized) return undefined;
  const direct = BY_NAME.get(normalized);
  if (direct) return direct;
  const words = normalized.split(' ');
  for (let length = Math.min(words.length, 6); length >= 1; length--) {
    const hit = BY_NAME.get(words.slice(0, length).join(' '));
    if (hit) return hit;
  }
  return undefined;
}

/* -------------------------------------------------------------------------- */
/* Engine coverage                                                            */
/* -------------------------------------------------------------------------- */

/** EU-27 member states. */
export const EU_MEMBERS = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
] as const;

export function isEuMember(code: string | null | undefined): boolean {
  return !!code && (EU_MEMBERS as readonly string[]).includes(code.toUpperCase());
}

/**
 * Nomenclatures the classifier answers in: the US, Canadian, EU and UK tariffs, the 6-digit global HS, and `national`
 * for any other country's own tariff (the result's `schedule` names it).
 */
export type Nomenclature = 'us' | 'ca' | 'eu' | 'gb' | 'global' | 'national';

export const NOMENCLATURE_LABELS: Record<Nomenclature, string> = {
  us: 'US HTS (10-digit)',
  ca: 'Canadian Customs Tariff (10-digit)',
  eu: 'EU Combined Nomenclature / TARIC',
  gb: 'UK Global Tariff (10-digit)',
  global: 'Harmonized System (6-digit)',
  national: 'National tariff',
};

/** Destinations shown first in pickers (most common parcel lanes). */
export const POPULAR_DESTINATIONS = [
  'US',
  'GB',
  'CA',
  'DE',
  'FR',
  'NL',
  'IT',
  'ES',
  'IE',
  'AU',
] as const;
/** Origins shown first in pickers. */
export const POPULAR_ORIGINS = [
  'CN',
  'US',
  'GB',
  'VN',
  'IN',
  'MX',
  'DE',
  'IT',
  'TR',
  'BD',
  'JP',
  'KR',
  'TW',
] as const;

/* -------------------------------------------------------------------------- */
/* Currencies                                                                 */
/* -------------------------------------------------------------------------- */

export const CURRENCIES = [
  ['USD', 'US Dollar', '$'],
  ['EUR', 'Euro', '€'],
  ['GBP', 'British Pound', '£'],
  ['CAD', 'Canadian Dollar', 'CA$'],
  ['AUD', 'Australian Dollar', 'A$'],
  ['NZD', 'New Zealand Dollar', 'NZ$'],
  ['CNY', 'Chinese Yuan', '¥'],
  ['HKD', 'Hong Kong Dollar', 'HK$'],
  ['TWD', 'New Taiwan Dollar', 'NT$'],
  ['JPY', 'Japanese Yen', '¥'],
  ['KRW', 'South Korean Won', '₩'],
  ['INR', 'Indian Rupee', '₹'],
  ['VND', 'Vietnamese Dong', '₫'],
  ['THB', 'Thai Baht', '฿'],
  ['SGD', 'Singapore Dollar', 'S$'],
  ['MYR', 'Malaysian Ringgit', 'RM'],
  ['IDR', 'Indonesian Rupiah', 'Rp'],
  ['PHP', 'Philippine Peso', '₱'],
  ['BDT', 'Bangladeshi Taka', '৳'],
  ['PKR', 'Pakistani Rupee', '₨'],
  ['MXN', 'Mexican Peso', 'MX$'],
  ['BRL', 'Brazilian Real', 'R$'],
  ['CHF', 'Swiss Franc', 'CHF'],
  ['SEK', 'Swedish Krona', 'kr'],
  ['NOK', 'Norwegian Krone', 'kr'],
  ['DKK', 'Danish Krone', 'kr'],
  ['PLN', 'Polish Złoty', 'zł'],
  ['CZK', 'Czech Koruna', 'Kč'],
  ['HUF', 'Hungarian Forint', 'Ft'],
  ['RON', 'Romanian Leu', 'lei'],
  ['TRY', 'Turkish Lira', '₺'],
  ['ILS', 'Israeli New Shekel', '₪'],
  ['AED', 'UAE Dirham', 'AED'],
  ['SAR', 'Saudi Riyal', 'SAR'],
  ['ZAR', 'South African Rand', 'R'],
  ['EGP', 'Egyptian Pound', 'E£'],
  ['NGN', 'Nigerian Naira', '₦'],
  ['KES', 'Kenyan Shilling', 'KSh'],
  ['ARS', 'Argentine Peso', 'AR$'],
  ['CLP', 'Chilean Peso', 'CLP$'],
  ['COP', 'Colombian Peso', 'COL$'],
  ['PEN', 'Peruvian Sol', 'S/'],
] as const satisfies ReadonlyArray<readonly [string, string, string]>;

export interface Currency {
  code: string;
  name: string;
  symbol: string;
}

export const CURRENCY_LIST: Currency[] = CURRENCIES.map(([code, name, symbol]) => ({
  code,
  name,
  symbol,
}));

const NON_EURO_EU: Record<string, string> = {
  CZ: 'CZK',
  DK: 'DKK',
  HU: 'HUF',
  PL: 'PLN',
  RO: 'RON',
  SE: 'SEK',
};
const COUNTRY_CURRENCY: Record<string, string> = {
  US: 'USD',
  CA: 'CAD',
  GB: 'GBP',
  AU: 'AUD',
  NZ: 'NZD',
  CN: 'CNY',
  HK: 'HKD',
  TW: 'TWD',
  JP: 'JPY',
  KR: 'KRW',
  IN: 'INR',
  VN: 'VND',
  TH: 'THB',
  SG: 'SGD',
  MY: 'MYR',
  ID: 'IDR',
  PH: 'PHP',
  BD: 'BDT',
  PK: 'PKR',
  MX: 'MXN',
  BR: 'BRL',
  CH: 'CHF',
  NO: 'NOK',
  TR: 'TRY',
  IL: 'ILS',
  AE: 'AED',
  SA: 'SAR',
  ZA: 'ZAR',
  EG: 'EGP',
  NG: 'NGN',
  KE: 'KES',
  AR: 'ARS',
  CL: 'CLP',
  CO: 'COP',
  PE: 'PEN',
};

/** Best-guess local currency for a country (defaults to USD). */
export function currencyForCountry(code: string | null | undefined): string {
  if (!code) return 'USD';
  const upper = code.toUpperCase();
  if (NON_EURO_EU[upper]) return NON_EURO_EU[upper];
  if (isEuMember(upper)) return 'EUR';
  return COUNTRY_CURRENCY[upper] ?? 'USD';
}

export function isCurrencyCode(code: string | null | undefined): boolean {
  return !!code && /^[A-Za-z]{3}$/.test(code);
}

/** A `reference.countries` row's links to other tariffs. */
export interface TariffLinks {
  code: string;
  customsUnion: string | null;
  classifySource: string | null;
  calculateSource: string | null;
}

/**
 * Whose HS lines (`classify`) or duty data (`calculate`) a country uses: the schedule it borrows itself, else its
 * customs union's, else its own. A customs union may name the member whose copy of the common tariff it is read from
 * (the GCC's `classify_source`/`calculate_source` is QA, Qatar customs' copy): its members, that member included, then
 * use that copy. `union` is the country's customs union row (null when it has none or isn't loaded).
 */
export function tariffFrom(
  row: TariffLinks,
  union: Pick<TariffLinks, 'classifySource' | 'calculateSource'> | null | undefined,
  kind: 'classify' | 'calculate',
): string {
  const own = kind === 'classify' ? row.classifySource : row.calculateSource;
  if (own) return own;
  if (!row.customsUnion) return row.code;
  const copy = kind === 'classify' ? union?.classifySource : union?.calculateSource;
  return copy ?? row.customsUnion;
}

/**
 * The same for SQL: `<alias>.classify_source` (or `calculate_source`), else its union's named copy, else the union,
 * else the code. `alias` is the `reference.countries` row being resolved.
 */
export function tariffFromSql(alias: string, kind: 'classify' | 'calculate'): string {
  const column = kind === 'classify' ? 'classify_source' : 'calculate_source';
  return `coalesce(${alias}.${column}, (select u.${column} from reference.countries u where u.code = ${alias}.customs_union), ${alias}.customs_union, ${alias}.code)`;
}
